const FieldTypes = {
  AMOUNT_RANGE: 'amount_range',
  MULTI_SELECT: 'multi_select',
  MULTI_INPUT: 'multi_input',
};

module.exports = FieldTypes;
